/**
 * Scroll Cards – status marker indicators
 *
 * Builds visual indicator divs inside .scroll-cards-status-markers that
 * correspond to each <section> card within .is-style-scroll-cards.
 * Highlights the active card based on 50 % visibility.
 */

var container        = null;
var indicator        = null;
var inner            = null;
var sections         = [];
var markers          = [];
var activeIndex      = -1;
var ticking          = false;
var visibility_buffer = 180;

/**
 * Build an inner wrapper and a <div> marker for each section.
 */
function buildMarkers() {

    inner = document.createElement( 'div' );
    inner.className = 'scroll-cards-status-markers__inner';
    indicator.appendChild( inner );

    sections.forEach( function() {

        var marker = document.createElement( 'div' );
        marker.className = 'scroll-cards-marker';

        var line = document.createElement( 'span' );
        line.className = 'scroll-cards-marker__line';
        marker.appendChild( line );

        inner.appendChild( marker );
        markers.push( marker );
    } );
}

/**
 * Determine which section is "active" (>= 50 % visible in the viewport).
 */
function updateActiveSection() {
    var vpHeight = window.innerHeight;

    // Read all rects up front before any DOM write to avoid forced reflow.
    var rects = sections.map( function( s ) { return s.getBoundingClientRect(); } );

    var firstRect = rects[ 0 ];
    var lastRect  = rects[ rects.length - 1 ];
    var inView    = firstRect.top < vpHeight && lastRect.bottom > ( vpHeight - visibility_buffer );
    inner.classList.toggle( 'is-hidden', ! inView );

    for ( var i = rects.length - 1; i >= 0; i-- ) {
        var rect    = rects[ i ];
        var top     = Math.max( rect.top, 0 );
        var bottom  = Math.min( rect.bottom, vpHeight );
        var visible = Math.max( 0, bottom - top );

        if ( visible >= vpHeight * 0.5 ) {
            setActive( i );
            return;
        }
    }

    // Fallback: pick whichever section covers the most viewport area.
    var bestIndex    = 0;
    var bestCoverage = 0;
    for ( var j = 0; j < rects.length; j++ ) {
        var r   = rects[ j ];
        var t   = Math.max( r.top, 0 );
        var b   = Math.min( r.bottom, vpHeight );
        var cov = Math.max( 0, b - t );
        if ( cov > bestCoverage ) {
            bestCoverage = cov;
            bestIndex    = j;
        }
    }
    setActive( bestIndex );
}

/**
 * Toggle the active class on markers and the dark-background modifier.
 */
function setActive( index ) {
    if ( index === activeIndex ) return;

    markers.forEach( function( marker, i ) {
        marker.classList.toggle( 'is-active', i === index );
    } );

    indicator.classList.toggle( 'has-dark-background', index === sections.length - 1 );

    activeIndex = index;
}

/**
 * Get the actual height of the sticky header element in pixels.
 */
function getHeaderHeight() {
    var header = document.getElementById( 'desktopHeader' );
    return header ? header.offsetHeight : 0;
}

/**
 * Smooth-scroll so the chosen section's top aligns below the header.
 *
 * Because sections are position: sticky, both getBoundingClientRect()
 * and offsetTop can return their stuck position rather than their
 * natural flow position. We calculate the target by summing the
 * heights of all preceding sections.
 */
function scrollToSection( index ) {
    var section = sections[ index ];
    if ( ! section ) return;

    var headerH      = getHeaderHeight();
    var containerTop = container.getBoundingClientRect().top + window.pageYOffset;

    var offset = 0;
    for ( var i = 0; i < index; i++ ) {
        offset += sections[ i ].offsetHeight;
    }

    var targetY = containerTop + offset - headerH;

    window.scrollTo( { top: targetY, behavior: 'smooth' } );
}

/**
 * Scroll handler (throttled via rAF).
 */
function onScroll() {
    if ( ! ticking ) {
        window.requestAnimationFrame( function() {
            updateActiveSection();
            ticking = false;
        } );
        ticking = true;
    }
}

/**
 * Initialise the module.
 */
function init() {
    container = document.querySelector( '.is-style-scroll-cards' );
    if ( ! container ) return;

    indicator = container.querySelector( '.scroll-cards-status-markers' );
    if ( ! indicator ) return;

    indicator.setAttribute( 'aria-hidden', 'true' );

    sections = Array.prototype.slice.call(
        container.querySelectorAll( ':scope > section' )
    );
    if ( ! sections.length ) return;

    buildMarkers();
    updateActiveSection();

    // When focus enters a section (e.g. via Tab), scroll to it so the
    // browser's native scroll-into-view doesn't fight with sticky layout.
    sections.forEach( function( section, i ) {
        section.addEventListener( 'focusin', function() {
            scrollToSection( i );
        } );
    } );

    window.addEventListener( 'scroll', onScroll, { passive: true } );
    window.addEventListener( 'resize', function() {
        updateActiveSection();
    }, { passive: true } );
}

var api = {
    init: init
};

export default api;
